import { Link } from 'react-router-dom';

export default function CategorySection() {
  const categories = [
    {
      title: '소형차',
      description: '경제적이고 연비가 좋은 소형차로 도심 주행에 최적화되어 있습니다',
      icon: 'ri-car-line',
      price: '50,000원~',
      image: 'https://static.readdy.ai/image/d842605c752dbbdb50edbc13280091c2/93a125d688080fc70d0186c3482d5690.png',
      link: '/compact-car',
      gradient: 'from-teal-500 to-cyan-500'
    },
    {
      title: '중형차',
      description: '편안한 승차감과 넉넉한 공간으로 장거리 여행에 적합합니다',
      icon: 'ri-car-line',
      price: '80,000원~',
      image: 'https://static.readdy.ai/image/d842605c752dbbdb50edbc13280091c2/7ca22c8fdea4436e553d01216d6b014b.png',
      link: '/midsize-car',
      gradient: 'from-indigo-500 to-pink-500'
    },
    {
      title: '대형차',
      description: '최고급 사양과 넓은 실내 공간으로 프리미엄 경험을 제공합니다',
      icon: 'ri-car-line',
      price: '120,000원~',
      image: 'https://static.readdy.ai/image/d842605c752dbbdb50edbc13280091c2/23c50bb584b76ee71b5a1ba70f6b9a03.png',
      link: '/fullsize-car',
      gradient: 'from-amber-500 to-orange-500'
    },
    {
      title: 'SUV',
      description: '넓은 공간과 강력한 성능으로 어떤 길도 자유롭게 달립니다',
      icon: 'ri-car-line',
      price: '100,000원~',
      image: 'https://static.readdy.ai/image/d842605c752dbbdb50edbc13280091c2/008c8503a7f027b3acb1642bd7d59351.png',
      link: '/suv-car',
      gradient: 'from-green-500 to-emerald-500'
    },
    {
      title: '승합차',
      description: '단체 여행이나 가족 나들이에 완벽한 넓은 공간을 제공합니다',
      icon: 'ri-car-line',
      price: '150,000원~',
      image: 'https://static.readdy.ai/image/d842605c752dbbdb50edbc13280091c2/9dedacb5b3ff2c14b614832979d8b64f.png',
      link: '/van-car',
      gradient: 'from-red-500 to-rose-500'
    },
    {
      title: '보험약관',
      description: '차량 임대 시 필수로 확인해야 할 보험 및 손해배상 약관입니다',
      icon: 'ri-file-shield-2-line',
      price: '필수 확인',
      image: 'https://public.readdy.ai/ai/img_res/f0d80a713b2dc33f2036bab7c71f8396.jpg',
      link: '/insurance-terms',
      gradient: 'from-slate-500 to-gray-600'
    }
  ];

  return (
    <section className="py-12 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 md:mb-4">
            차량 카테고리
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-gray-600 max-w-2xl mx-auto px-4">
            단기렌트, 월렌트, 사고대차, 보험대차, 웨딩카" 등. 다양한 차종을 선택하세요.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8">
          {categories.map((category, index) => (
            <Link
              key={index}
              to={category.link}
              className="group bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden cursor-pointer"
            >
              <div className="relative h-48 sm:h-56 md:h-64 overflow-hidden">
                <img
                  src={category.image}
                  alt={category.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className={`absolute inset-0 bg-gradient-to-t ${category.gradient} opacity-20 group-hover:opacity-30 transition-opacity`}></div>
              </div>

              <div className="p-4 md:p-6">
                <div className="flex items-center justify-between mb-3 md:mb-4">
                  <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-900">{category.title}</h3>
                  <div className={`w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-gradient-to-br ${category.gradient} rounded-full`}>
                    <i className={`${category.icon} text-white text-lg md:text-xl`}></i>
                  </div>
                </div>

                <p className="text-xs sm:text-sm md:text-base text-gray-600 mb-3 md:mb-4 leading-relaxed">
                  {category.description}
                </p>

                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-xs text-gray-500 mb-1">1일 기준</p>
                    <p className="text-base sm:text-lg md:text-xl font-bold text-primary">{category.price}</p>
                  </div>
                  <div className="flex items-center text-xs sm:text-sm text-primary font-medium group-hover:translate-x-2 transition-transform">
                    <span className="whitespace-nowrap">자세히 보기</span>
                    <i className="ri-arrow-right-line ml-1 md:ml-2"></i>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
